import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function Preloader() {
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);
    
    return () => clearTimeout(timer);
  }, []);
  
  return (
    <AnimatePresence>
      {loading && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4, ease: 'easeOut' }}
          className="fixed inset-0 z-50 flex items-center justify-center overflow-hidden bg-[radial-gradient(circle_at_top,#f8fbff,#effcff_38%,#e2f7fb)] dark:bg-[radial-gradient(circle_at_top,#020617,#0f172a_42%,#020617)]"
        >
          <div className="absolute inset-0 opacity-20" style={{ backgroundImage: 'linear-gradient(rgba(15,23,42,0.08) 1px, transparent 1px), linear-gradient(90deg, rgba(15,23,42,0.08) 1px, transparent 1px)', backgroundSize: '72px 72px' }} />
          <div className="flex flex-col items-center px-6 text-center">
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.4, ease: 'easeOut' }}
              className="mb-8"
            >
              <div className="relative h-24 w-24">
                <motion.div
                  className="absolute inset-0 rounded-full border border-primary/20 bg-white/60 shadow-[0_20px_50px_rgba(15,23,42,0.12)] backdrop-blur dark:bg-slate-950/50"
                  initial={{ scale: 0.8 }}
                  animate={{ scale: 1 }}
                  transition={{ duration: 0.3 }}
                />
                <motion.div
                  className="absolute inset-2 rounded-full border-2 border-transparent border-t-primary border-r-primary/30"
                  animate={{ rotate: 360 }}
                  transition={{ duration: 1.1, repeat: Infinity, ease: 'linear' }}
                />
                <motion.div
                  className="absolute inset-0 flex items-center justify-center"
                  initial={{ scale: 0.7, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  transition={{ delay: 0.15, duration: 0.3 }}
                >
                  <img src="/assets/logo/mef-logo.png" alt="MakersPlace Educational Foundation" className="h-10 w-auto" />
                </motion.div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.4 }}
              className="text-center"
            >
              <p className="text-xs font-bold uppercase tracking-[0.3em] text-primary">MakersPlace Educational Foundation</p>
              <h1 className="mt-3 text-2xl font-semibold text-slate-900 dark:text-white">
               Loading..
              </h1>
              <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.5, duration: 0.3 }}
                className="mt-3 text-sm text-slate-600 dark:text-slate-300"
              >
               .......................
              </motion.p>
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
